export const arrayBufferToBase64 = (buffer: Uint8Array): string => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa
    ? window.btoa(binary)
    : Buffer.from(buffer).toString("base64");
};
